var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.7133 4L27.0447 16.3532L30.1413 9.07305L43.7133 4Z",
    fill: "#E17726"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30298 4L21.8068 16.4685L18.8585 9.07305L5.30298 4Z",
    fill: "#E27625"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.718 32.6426L33.2874 39.4286L42.7746 42.0475L45.4758 32.7908L37.718 32.6426Z",
    fill: "#E27625"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54041 32.7908L6.22517 42.0475L15.7124 39.4286L11.2982 32.6426L3.54041 32.7908Z",
    fill: "#E27625"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2023 21.1793L12.5504 25.1653L21.9553 25.5935L21.6259 15.4639L15.2023 21.1793Z",
    fill: "#E27625"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8142 21.1793L27.2753 15.3486L27.0447 25.5935L36.4496 25.1654L33.8142 21.1793Z",
    fill: "#E27625"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7126 39.4292L21.3787 36.6786L16.5032 32.8574L15.7126 39.4292Z",
    fill: "#E27625"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6213 36.6786L33.2874 39.4292L32.4967 32.8574L27.6213 36.6786Z",
    fill: "#E27625"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2874 39.4293L27.6213 36.6787L28.0661 40.3682L28.0166 41.9165L33.2874 39.4293Z",
    fill: "#D5BFB2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7126 39.4293L20.9833 41.9165L20.9504 40.3682L21.3787 36.6787L15.7126 39.4293Z",
    fill: "#D5BFB2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0821 30.4193L16.3713 29.0357L19.6985 27.5039L21.0821 30.4193Z",
    fill: "#233447"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9177 30.4193L29.3013 27.5039L32.6613 29.0357L27.9177 30.4193Z",
    fill: "#233447"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7125 39.4286L16.5359 32.6426L11.2982 32.7908L15.7125 39.4286Z",
    fill: "#CC6228"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4635 32.6426L33.2871 39.4286L37.7177 32.7908L32.4635 32.6426Z",
    fill: "#CC6228"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4496 25.165L27.0447 25.5933L27.9177 30.4194L29.3012 27.504L32.6613 29.0358L36.4496 25.165Z",
    fill: "#CC6228"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3717 29.0358L19.6988 27.504L21.0824 30.4194L21.9553 25.5933L12.5504 25.165L16.3717 29.0358Z",
    fill: "#CC6228"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5504 25.165L16.5035 32.857L16.3717 29.0358L12.5504 25.165Z",
    fill: "#E27525"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6611 29.0358L32.4963 32.857L36.4494 25.165L32.6611 29.0358Z",
    fill: "#E27525"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9552 25.5938L21.0823 30.4197L22.1858 36.1186L22.4164 28.6079L21.9552 25.5938Z",
    fill: "#E27525"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0447 25.5938L26.6 28.5913L26.8141 36.1186L27.9177 30.4197L27.0447 25.5938Z",
    fill: "#E27525"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9174 30.4196L26.8138 36.1185L27.621 36.6786L32.4963 32.8573L32.6611 29.0361L27.9174 30.4196Z",
    fill: "#F5841F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3713 29.0361L16.5031 32.8573L21.3786 36.6786L22.1856 36.1185L21.0821 30.4196L16.3713 29.0361Z",
    fill: "#F5841F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0164 41.9158L28.0658 40.3676L27.6541 40.0052H21.3457L20.9504 40.3676L20.9833 41.9158L15.7126 39.4287L17.5574 40.9441L21.2962 43.53H27.7035L31.4424 40.9441L33.2871 39.4287L28.0164 41.9158Z",
    fill: "#C0AC9D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6211 36.6782L26.814 36.1182H22.1857L21.3786 36.6782L20.9504 40.3677L21.3457 40.0053H27.6541L28.0658 40.3677L27.6211 36.6782Z",
    fill: "#161616"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4053 17.1603L45.8053 10.3413L43.7135 4L27.6213 15.9415L33.8144 21.1791L42.5441 23.7321L44.4711 21.4756L43.6311 20.8663L44.9817 19.6473L43.9605 18.8403L45.2947 17.8356L44.4053 17.1603Z",
    fill: "#763E1A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1947 10.3413L4.61121 17.1603L3.7053 17.8356L5.03945 18.8403L4.01825 19.6473L5.36886 20.8663L4.52885 21.4756L6.45594 23.7321L15.202 21.1791L21.3786 15.9415L5.30298 4L3.1947 10.3413Z",
    fill: "#763E1A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5436 23.7327L33.8141 21.1797L36.4494 25.1657L32.4963 32.8576L37.7177 32.7917H45.4754L42.5436 23.7327Z",
    fill: "#F5841F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2018 21.1797L6.45576 23.7327L3.54041 32.7917H11.2982L16.503 32.8576L12.5501 25.1657L15.2018 21.1797Z",
    fill: "#F5841F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0447 25.5936L27.6212 15.9416L30.1413 9.07324H18.8586L21.3786 15.9416L21.9551 25.5936L22.1693 28.6242L22.1858 36.1185H26.814L26.8306 28.6242L27.0447 25.5936Z",
    fill: "#F5841F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.9734b55c4229f7d95e7f75d2987cc94c.svg";
export { ForwardRef as ReactComponent };